import PropTypes from 'prop-types';
import clsx from 'clsx';
import Image from '@/components/Image';
import Link from '@/components/Link';

const defaultProps = {
  url: null,
  defaultSize: 'w-56 h-56',
  badgeClassName: null,
};

const propTypes = {
  badge: PropTypes.object.isRequired,
  url: PropTypes.string,
  defaultSize: PropTypes.string,
  badgeClassName: PropTypes.string,
};

export default function CertificationBadge({
  badge: {
    node: { sourceUrl, srcSet, sizes },
  },
  url,
  defaultSize,
  badgeClassName,
  title,
}) {
  const hasLink = url !== null;

  const badge = (
    <Image src={sourceUrl} srcSet={srcSet} sizes={sizes} alt={title} />
  );

  if (hasLink) {
    return (
      <Link href={url} title="Más información">
        <div className="h-36 w-36 overflow-hidden rounded-full bg-gray-100 shadow-lg lg:shadow-xl">
          {badge}
        </div>
      </Link>
    );
  }

  return (
    <div
      className={clsx(
        defaultSize,
        badgeClassName,
        'relative rounded-full bg-gray-100 shadow-lg lg:shadow-xl ring-1 ring-white ring-opacity-20'
      )}
    >
      <div className="relative z-10 h-full w-full">{badge}</div>
    </div>
  );
}

CertificationBadge.defaultProps = defaultProps;
CertificationBadge.propTypes = propTypes;
